//-- Copyright (c) 2021 TMT Insights Group, LLC
import { configureStore, ThunkAction, UnknownAction } from '@reduxjs/toolkit';
import initializers from './initializers';
import auth from './slices/authSlice';
import bulkSearch from './slices/bulkSearchSlice';
import constants from './slices/constantsSlice';
import dashboard from './slices/dashboardSlice';
import dataTable from './slices/dataTableSlice';
import fileManager from './slices/fileManagerSlice';
import fileQueue from './slices/fileQueueSlice';
import job from './slices/jobSlice';
import layout from './slices/layoutSlice';
import orderPlacement from './slices/orderPlacementSlice';
import profile from './slices/profileSlice';
import title from './slices/titleSlice';
import titleV2 from './slices/titleV2Slice';
import notification from './slices/notificationSlice';
import taskDrawer from './slices/taskDrawerSlice';
import packaging from './slices/packagingSlice';
import packagingTimeline from './slices/packagingTimelineSlice';
import exceptionDrawer from './slices/exceptionDrawerSlice';
import ingestManagement from './slices/ingestManagementSlice';
import focusCalendar from './slices/focusCalendarSlice';
import focusNewSchedule from './slices/focusNewScheduleSlice';
import focusSchedule from './slices/focusScheduleSlice';
import analyticsMiddleware from './analyticsMiddleware';
import titleNavigationDrawer from './slices/titleNavigationDrawerSlice';

const store = configureStore({
  reducer: {
    auth,
    bulkSearch,
    constants,
    dashboard,
    dataTable,
    fileManager,
    fileQueue,
    job,
    layout,
    orderPlacement,
    profile,
    title,
    titleV2,
    notification,
    taskDrawer,
    packaging,
    packagingTimeline,
    exceptionDrawer,
    ingestManagement,
    focusCalendar,
    titleNavigationDrawer,
    focusNewSchedule,
    focusSchedule
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(analyticsMiddleware)
});

initializers.map((initializer) => {
  initializer(store);
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, UnknownAction>;
